var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe-container',{attrs:{"iframe-id":_vm.iframeId,"empty-state-description":"This template has no preview yet","preview-content":_vm.previewContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }